import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_Please_upload_a_photo_of_your__ELL,
  TXTWCL_We_havenXt_received_your_ident_ELL_1
} from './AuthenticationRequired.messages.json';
import { message } from './AuthenticationRequired.scss';

const AuthenticationRequired: React.FC = () => (
  <Typography className={message}>
    <Translation {...TXTWCL_We_havenXt_received_your_ident_ELL_1} />{' '}
    <Translation {...TXTWCL_Please_upload_a_photo_of_your__ELL} />
  </Typography>
);

export default AuthenticationRequired;
